import styled from '@emotion/styled'
import theme from '@utils/theme'

export const CreatedByWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
`
export const ProfileWrapper = styled.div<{ bgcolor?: string }>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${(props: any) => props.bgcolor};
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ProfilePreview = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 2px;
  align-items: self-start;
`

export const Name = styled.p`
  color: ${({ theme }: any) => theme.colors.text};
  font-weight: 200;
  letter-spacing: 0.75px;
  line-height: 20px;
`

export const Number = styled.p`
  color: ${({ theme }: any) => theme.colors.text50};
  font-size: 12px;
  letter-spacing: 0.75px;
  line-height: 20px;
`

export const MatchDateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  line-height: 1.4;
`

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const StatusToggle = styled.div<{ active: boolean }>`
  width: 40px;
  height: 20px;
  border-radius: 20px;
  background-color: ${({ active, theme }: any) =>
    active ? theme.colors.success : theme.colors.red500};
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ active }) => (active ? '20px' : '2px')};
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.2s ease-in-out;
  }
`

export const BanTitle = styled.p`
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: ${theme.colors.primary};
`
export const BanSubtitle = styled.p`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.text};
`
export const outline = `
  background:transparent;
  border:1px solid ${theme.colors.primary};
  color:${theme.colors.primary}

`
